import React, { useEffect, useState } from "react";
import { Empty, Spin } from "antd";
import { ArrowLeftOutlined, FileTextOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import { SectionCard } from "../Components/SectionCard";
import {
  PatchNoteReleaseDetail,
  ReleaseHeader,
} from "../Components/PatchNoteReleaseDetail";
import { showError } from "../utils";
import {
  fetchPatchNotesManifest,
  findPatchNoteRelease,
  PatchNoteRelease,
} from "../utils/patchNotes";
import "./PatchNotes.css";

export const PatchNoteReleasePage = () => {
  const { releaseId } = useParams<{ releaseId: string }>();
  const [release, setRelease] = useState<PatchNoteRelease>();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!releaseId) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    const load = async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const manifest = await fetchPatchNotesManifest();
        const match = findPatchNoteRelease(manifest.releases || [], releaseId);
        if (!match) {
          setNotFound(true);
          setRelease(undefined);
        } else {
          setRelease(match);
        }
      } catch (error) {
        showError("Failed to load patch notes", error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [releaseId]);

  if (loading) {
    return (
      <div className="patch-notes-page patch-notes-page--loading">
        <Spin size="large" />
      </div>
    );
  }

  if (notFound || !release) {
    return (
      <div className="patch-notes-page">
        <div className="account-header">
          <h1>Release not found</h1>
          <p>
            <Link to="/patch-notes" className="patch-notes-back-link">
              <ArrowLeftOutlined /> All releases
            </Link>
          </p>
        </div>
        <Empty description="This patch note release could not be found." />
      </div>
    );
  }

  return (
    <div className="patch-notes-page">
      <div className="account-header">
        <p className="patch-notes-back">
          <Link to="/patch-notes" className="patch-notes-back-link">
            <ArrowLeftOutlined /> All releases
          </Link>
        </p>
        <ReleaseHeader release={release} showCopyLink />
      </div>

      <SectionCard icon={<FileTextOutlined />} title="Release Notes">
        <PatchNoteReleaseDetail release={release} showHeader={false} />
      </SectionCard>
    </div>
  );
};

export default PatchNoteReleasePage;
